export default {
	hebrewOnly  : "אותיות בעברית בלבד",
	numbersOnly : "מספרים בלבד",
	phoneInvalid: "מספר טלפון לא תקין"
};
